import { useEffect, useState } from 'react';
import API from '../../api/smsGateway';
import translations from '../../translations/de';
import formatTime from './formatTime';
import SmsGatewayOutagesModal from './SmsGatewayOutagesModal';

// The API checks the gateway every 5 minutes; asking every minute is plenty.
const REFRESH_MS = 60 * 1000;

export default function SmsGatewayStatus() {
    const [gateway, setGateway] = useState(null);
    const [showOutages, setShowOutages] = useState(false);

    useEffect(() => {
        let active = true;
        const load = async () => {
            try {
                const res = await API.getStatus();
                if (active) setGateway(res.data);
            } catch (error) {
                if (active) setGateway(null);
            }
        };
        load();
        const timer = setInterval(load, REFRESH_MS);
        return () => {
            active = false;
            clearInterval(timer);
        };
    }, []);

    const status = gateway?.status ?? 'unknown';
    const label = {
        up: translations.sms_server_up,
        down: translations.sms_server_down,
        unknown: translations.sms_server_unknown,
    }[status];

    const lines = [];
    if (status === 'down' && gateway.downSince) {
        lines.push(`${translations.sms_server_down_since} ${formatTime(gateway.downSince)}`);
    }
    if (status === 'up' && gateway.upSince) {
        lines.push(`${translations.sms_server_up_since} ${formatTime(gateway.upSince)}`);
    }
    lines.push(
        gateway?.checkedAt
            ? `${translations.sms_server_checked_at} ${formatTime(gateway.checkedAt)}`
            : translations.sms_server_never_checked,
    );

    return (
        <>
            <div className={`SmsGatewayStatus ${status}`} onClick={() => setShowOutages(true)}>
                <span className="dot" />
                <span className="label">{label}</span>
                <div className="tooltip">
                    {lines.map((line) => (
                        <div key={line}>{line}</div>
                    ))}
                </div>
            </div>
            {showOutages && <SmsGatewayOutagesModal onClose={() => setShowOutages(false)} />}
        </>
    );
}
